import { styled } from '@mui/material/styles';
import { Field } from '.';

export const StyledField = styled(Field)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1),
  width: 220,
}));
